import React from "react";
import type { Key } from "react";
import { ListBoxItem, Select } from "@appsmith/wds";
import type { CalendarState } from "@react-stately/calendar";

import { useYearOptions } from "../utils/calendar";

interface CalendarYearDropdownProps {
  state: CalendarState;
  /** Accessible name for the year dropdown. */
  ariaLabel?: string;
  /** Placeholder shown when no year is selected. */
  placeholder?: string;
}

export function CalendarYearDropdown({
  ariaLabel = "Year",
  placeholder = "Select Year",
  state,
}: CalendarYearDropdownProps) {
  const years = useYearOptions(state);

  const onChange = (value: Key | null) => {
    const index = Number(value);
    const date = years[index].value;

    state.setFocusedDate(date);
  };

  return (
    <Select
      aria-label={ariaLabel}
      onSelectionChange={onChange}
      placeholder={placeholder}
      selectedKey={20}
      size="small"
    >
      {years.map((year, i) => (
        <ListBoxItem id={i} key={i} textValue={year.formatted}>
          {year.formatted}
        </ListBoxItem>
      ))}
    </Select>
  );
}
